<template>
  <div>
    <HistoryTemplate :scores="scores"></HistoryTemplate>
  </div>
</template>

<script>
  import HistoryTemplate from '@/components/templates/HistoryTemplate.vue';
  import { mapGetters } from 'vuex';

  export default {
    components: { HistoryTemplate },
    created() {
      this.$store.dispatch('fetchHistory');
    },
    computed: {
      ...mapGetters({ scores: 'history' }),
    },
  };
</script>
